export default __webpack_public_path__ + "static/img/vogue_scene_animated_0710.5fe83fd.webp";